import React, { useRef, useEffect } from "react";
import PageLayout from "../../../../UiKit/Wizard/Page/PageLayout";
import "./liveChatCard1.css";
import LiveChatjson from "../../../../Images/livechat.json";
import Lottie from "react-lottie";
import useChatbot from "../../../../Hooks/useChatbot";
import WelcomeScreenSuggestedActions from "../../WelcomeScreen/WelcomeScreenSuggestedActions/WelcomeScreenSuggestedActions";
import classes from "../../WelcomeScreen/WelcomeScreen.module.css";
import translation from "../translation";
import { useLanguage } from "../../../../UiKit/Wizard/langugeContext";

const LiveChatCard2 = () => {
  const containerRef = useRef(null);
  const { setShowWelcomScreen } = useChatbot();
  const { currentLanguage } = useLanguage();
  const liveChatTranslations = translation[currentLanguage]["LiveChatCard2"];

  useEffect(() => {
    const bubble =containerRef.current && containerRef.current.closest(".bubble");
    if (bubble) {
      bubble.style.border = "none";
      bubble.style.boxShadow = "none";
    }

    const scrollEl =
    document.querySelector('.webchat__scrollable') ||
    document.querySelector('.webchat__basic-transcript__scrollable');

  const stackedLayout =
    document.querySelector('.webchat__stacked-layout') ||
    (scrollEl && scrollEl.firstElementChild);

  if (!scrollEl || !stackedLayout) return;

  const scrollToBottom = () => {
    requestAnimationFrame(() => {
      scrollEl.scrollTo({
        top: scrollEl.scrollHeight,
        behavior: 'smooth',
      });
    });
  };

  const observer = new MutationObserver(scrollToBottom);
  observer.observe(stackedLayout, { childList: true });

  scrollToBottom(); // scroll on first mount too

  return () => observer.disconnect();
}, []);

  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: LiveChatjson,
    rendererSettings: { preserveAspectRatio: "xMidYMid slice" },
  };

  return (
    <div ref={containerRef} className="livechat-card1-wrapper">
      <PageLayout>
        <PageLayout.Content>
          <div className="livechat-container">
            <div className="livechat-header-line">
              <span className="livechat-title">{liveChatTranslations.welcomeBack}</span>
              <div className="livechat-line"></div>
            </div>

            <div style={{ textAlign: "center", margin: "24px 0 16px" }}>
              <Lottie options={defaultOptions} height={106} width={106} />
            </div>

            <div className="livechat-welcome-text">{liveChatTranslations.welcomeBack
              }</div>
            <div
              className={classes["welcome-screen__actions-container"]}
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "8px",
                textAlign: "justify",
              }}
            >
              <WelcomeScreenSuggestedActions />
            </div>
          </div>
        </PageLayout.Content>
      </PageLayout>
    </div>
  );
};

export default LiveChatCard2;
